module.exports = "/assets/data/f8c11d16e305e3873d6d673569bf0d41-EX1.data.json";